import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import { API_BASE_URL } from '../../constants'
import { baseQuery } from '../base/baseQuery'

export const rulesApi = createApi({
  reducerPath: 'rulesApi',
  baseQuery: baseQuery,
  tagTypes: ['Rules'],
  endpoints: (builder) => ({
    getRulesByLessonId: builder.query({
      query: (lessonId) => `/backoffice/rules/lesson/${lessonId}`,
      providesTags: ['Rules'],
    }),
    getRuleById: builder.query({
      query: (id) => `/backoffice/rules/${id}`,
      providesTags: ['Rules'],
    }),
    addRule: builder.mutation({
      query: (formData) => ({
        url: '/backoffice/rules',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Rules'],
    }),
    updateRule: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/rules/${id}`,
        method: 'PATCH',
        body: formData,
      }),
      invalidatesTags: ['Rules'],
    }),
    deleteRule: builder.mutation({
      query: (id) => ({
        url: `/backoffice/rules/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Rules'],
    }),
  }),
})

export const {
  useGetRulesByLessonIdQuery,
  useGetRuleByIdQuery,
  useAddRuleMutation,
  useUpdateRuleMutation,
  useDeleteRuleMutation,
} = rulesApi
